import { ReplicantError } from '../Errors';
import type { KeyValuePairs, KeyValueStoreAPI, KeyValueStoreSendOpts } from '../api/KeyValueStoreAPI';
import type DB from '../db/DB';

export default class ServerReplicantKeyValueStore implements KeyValueStoreAPI {
    constructor(private opts: { dateNow: () => number; db: DB<any> }) {}

    async getBatch(keys: string[]): Promise<KeyValuePairs> {
        const values = await Promise.all(keys.map((key) => this.opts.db.kvStore.fetch(key, this.opts.dateNow())));
        const result: KeyValuePairs = {};

        keys.forEach((key, i) => {
            const value = values[i];
            if (value !== null && value !== undefined) {
                result[key] = value;
            }
        });

        return result;
    }

    async get(key: string): Promise<string | null> {
        return (await this.getBatch([key]))[key] || null;
    }

    async sendBatch(pairs: KeyValuePairs, opts?: KeyValueStoreSendOpts): Promise<void> {
        for (const key in pairs) {
            if (!pairs[key] || typeof pairs[key] !== 'string') {
                throw new ReplicantError(
                    `Invalid value for key: '${key}'.`,
                    'replication_error',
                    'key_value_storage_error',
                );
            }
        }

        const now = this.opts.dateNow();

        await Promise.all(
            Object.entries(pairs).map(([key, value]) =>
                this.opts.db.kvStore.write(key, value, now, { expiresInMs: opts?.expiresInMs }),
            ),
        );
    }

    async send(key: string, value: string, opts?: KeyValueStoreSendOpts): Promise<void> {
        await this.sendBatch({ [key]: value }, opts);
    }
}
